let audioCtx = null

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)()
  }
  if (audioCtx.state === "suspended") {
    audioCtx.resume()
  }
  return audioCtx
}

export const playSound = (type) => {
  try {
    const ctx = getAudioContext()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)

    const now = ctx.currentTime

    if (type === "click") {
      osc.type = "sine"
      osc.frequency.setValueAtTime(450, now)
      osc.frequency.exponentialRampToValueAtTime(150, now + 0.06)
      gain.gain.setValueAtTime(0.2, now)
      gain.gain.linearRampToValueAtTime(0.01, now + 0.06)
      osc.start(now)
      osc.stop(now + 0.06)
    } else if (type === "correct" || type === "win") {
      // Ascending major arpeggio chime
      osc.type = "triangle"
      osc.frequency.setValueAtTime(523.25, now) // C5
      osc.frequency.setValueAtTime(659.25, now + 0.08) // E5
      osc.frequency.setValueAtTime(783.99, now + 0.16) // G5
      osc.frequency.setValueAtTime(1046.50, now + 0.24) // C6
      gain.gain.setValueAtTime(0.18, now)
      gain.gain.linearRampToValueAtTime(0.18, now + 0.24)
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.45)
      osc.start(now)
      osc.stop(now + 0.45)
    } else if (type === "lose" || type === "too_high") {
      // Descending buzz slide
      osc.type = "sawtooth"
      osc.frequency.setValueAtTime(220, now)
      osc.frequency.linearRampToValueAtTime(110, now + 0.35)
      gain.gain.setValueAtTime(0.12, now)
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.35)
      osc.start(now)
      osc.stop(now + 0.35)
    } else if (type === "bet") {
      osc.type = "sine"
      osc.frequency.setValueAtTime(587.33, now) // D5
      osc.frequency.exponentialRampToValueAtTime(880.00, now + 0.08) // A5
      gain.gain.setValueAtTime(0.15, now)
      gain.gain.linearRampToValueAtTime(0.01, now + 0.08)
      osc.start(now)
      osc.stop(now + 0.08)
    } else if (type === "gameover" || type === "fanfare") {
      // Stately fan-fare
      osc.type = "triangle"
      const notes = [261.63, 329.63, 392.00, 523.25, 392.00, 523.25]
      const times = [0, 0.08, 0.16, 0.24, 0.36, 0.48]
      notes.forEach((freq, i) => {
        osc.frequency.setValueAtTime(freq, now + times[i])
      })
      gain.gain.setValueAtTime(0.2, now)
      gain.gain.linearRampToValueAtTime(0.2, now + 0.48)
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.8)
      osc.start(now)
      osc.stop(now + 0.8)
    } else if (type === "alarm") {
      // Rapid warning siren
      osc.type = "sawtooth"
      osc.frequency.setValueAtTime(500, now)
      osc.frequency.linearRampToValueAtTime(800, now + 0.15)
      osc.frequency.linearRampToValueAtTime(500, now + 0.3)
      gain.gain.setValueAtTime(0.08, now)
      gain.gain.linearRampToValueAtTime(0.08, now + 0.25)
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.35)
      osc.start(now)
      osc.stop(now + 0.35)
    }
  } catch (e) {
    console.warn("AudioContext block or not supported", e)
  }
}
